import type { NotificationAction } from "@/components/NotificationBell/NotificationItem";
import { type Notification, NotificationPanel } from "@/components/NotificationBell/NotificationPanel";

export interface NotificationsShowViewProps {
  /** The recipient's notifications, newest first, rendered in the full-screen panel. */
  notifications: Notification[];
  /** Fired when the user triggers an inline notification action (accept / decline / etc.). */
  onAction: (action: NotificationAction) => void;
}

/**
 * Presentational content for the notifications full-screen page. The parent screen owns the
 * title/back chrome, so the panel renders in its `screen` variant with no chrome of its own.
 * All Inertia wiring (live props, seen-marker, action routing) lives in the container.
 */
export function NotificationsShowView({ notifications, onAction }: NotificationsShowViewProps) {
  return <NotificationPanel notifications={notifications} onAction={onAction} variant="screen" />;
}
